import { render } from "./BasicMenu.vue?vue&type=template&id=268e9443"
import script from "./BasicMenu.vue?vue&type=script&lang=js"
export * from "./BasicMenu.vue?vue&type=script&lang=js"

import "./BasicMenu.vue?vue&type=style&index=0&id=268e9443&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__